var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4Cpom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.9,
    y: 0.9,
    width: 18.2,
    height: 18.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.64,
    cy: 5.19,
    r: 2.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.05,
    cy: 5.19,
    r: 2.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.36,
    cy: 5.19,
    r: 2.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.64,
    cy: 10,
    r: 2.05
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.05,
    cy: 10,
    r: 2.05
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.36,
    cy: 10,
    r: 2.05
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.64,
    cy: 14.81,
    r: 2.05
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.05,
    cy: 14.81,
    r: 2.05
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.36,
    cy: 14.81,
    r: 2.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Cpom);
export default __webpack_public_path__ + "static/media/4cpom.0ddc9d2b2d95b25e64f7cd49e5760ee0.svg";
export { ForwardRef as ReactComponent };